import script from "./PropertyFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyFormModal.vue?vue&type=script&setup=true&lang=js"

import "./PropertyFormModal.vue?vue&type=style&index=0&id=129e7d99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129e7d99"]])

export default __exports__